import { axiosUser } from './axiosInstance';

/**
 * Kuicko reward earned by an LK booking (LK ⇄ Kuicko partner rewards).
 * Backend: lk-mobile-backend app/controllers/user/partner_rewards_controller.ts
 *
 * Response `data`:
 *   { state: 'none' | 'pending' | 'ready' | 'redeemed' | 'expired',
 *     title, description, discountType, value, minOrder, expiresAt,
 *     revealed, code (only after reveal), links: { web, android } }
 */
export const getBookingPartnerReward = async (bookingId) => {
  const response = await axiosUser.get(`/user/bookings/${encodeURIComponent(bookingId)}/partner-reward`);
  return response.data?.data ?? { state: 'none' };
};

/** Marks the scratch card revealed and returns the reward with its code. Idempotent. */
export const revealBookingPartnerReward = async (bookingId) => {
  const response = await axiosUser.post(
    `/user/bookings/${encodeURIComponent(bookingId)}/partner-reward/reveal`
  );
  return response.data?.data;
};

/**
 * The Kuicko reward a booking of this event earns right now (public).
 * `data`: { partner: 'kuicko', offer: null | { title, summary, minBookingAmount, endsAt, perMonth } }
 */
export const getEventPartnerOffer = async (serviceId) => {
  const response = await axiosUser.get(`/services/${encodeURIComponent(serviceId)}/partner-offer`);
  return response.data?.data ?? { partner: 'kuicko', offer: null };
};

/**
 * Kuicko Dine Now restaurants and their live dine-in offers (public, cached
 * server-side). `data`: { headline: 'Up to 15% off' | null, restaurantCount,
 * offerCount, restaurants: [{ name, logoUrl, coverUrl, address, offer }] }
 */
export const getKuickoDineNow = async () => {
  const response = await axiosUser.get('/partners/kuicko/dine-now');
  return response.data?.data ?? { headline: null, restaurantCount: 0, offerCount: 0, restaurants: [] };
};
